import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "config/axiosInstance";
import { toast } from "react-toastify";

export const GetAllClaimPayment = createAsyncThunk(
    "payment/GetAllClaimPayment",
    async (body) => {
        try {
            const response = await apiInstance.post("insurance/paymentreconList", body);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);
export const ViewSinglePayment = createAsyncThunk(
    "payment/ViewSinglePayment",
    async (body) => {
        try {
            const response = await apiInstance.post("insurance/paymentreconView", body);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);
export const SingleClearPayment = createAsyncThunk(
    "payment/SingleClearPayment",
    async (body) => {
        try {
            const response = await apiInstance.post("insurance/paymentnoticeCreate", body);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);
export const MultipleClearPayment = createAsyncThunk(
    "payment/MultipleClearPayment",
    async (body) => {
        try {
            const response = await apiInstance.post("insurance/paymentnoticeCreate", body);
            return response.data;
        } catch (error) {
            toast.error(error.response?.data || "Something went wrong");
        }
    }
);
